<template lang="pug">
v-list-group.outlined.mt-2
  template(v-slot:activator)
    v-list-item-content
      v-list-item-title {{hint.title}}
      v-list-item-subtitle Ответ: {{hint.text}}
    v-list-item-action
      v-menu(
        transition="slide-y-transition"
        offset-y
      )
        template(v-slot:activator="{ on }")
          v-btn(v-on="on" icon)
            v-icon mdi-menu
        v-card.pa-4
          v-card-actions
            v-tooltip(bottom) Редактировать типовой вопрос
              template(#activator="{ on: on}")
                v-btn.mr-2(color="info" @click.stop="$emit('editHint', hint)" v-on="on" icon)
                  v-icon mdi-pencil
            v-tooltip(bottom) Удалить типовой вопрос
              template(#activator="{ on: on}")
                v-btn.mr-2(color="error" @click.stop="deleteHint" v-on="on" icon)
                  v-icon mdi-close

  div.mx-4.mb-4
    span.black--text Проекты:
      v-chip-group(v-if="hint.projects.length")
        v-chip(
          v-for="project in hint.projects"
          :key="project.id"
          color="info"
          close
          @click:close="unBindProject(project.id)"
          ) {{project.name}}
      span.ml-2(v-else) нет привязанных проектов

  div.mx-4.mb-4.black--text
    span Ключевые слова:
    span.ml-2(v-if="!hint.require_tags.length && !hint.not_require_tags.length") Нет привязанных ключевых слов
    v-row.pa-0.ma-0(v-if="hint.require_tags.length")
      span.mt-3.mr-2 обязательные:
      v-chip-group()
        v-chip(
          v-for="tag in hint.require_tags"
          :key="tag.id"
          color="primary"
          close
          @click:close="unBindTag(tag.id)"
          ) {{tag.name}}

    v-row.pa-0.ma-0(v-if="hint.not_require_tags.length")
      span.mt-3.mr-2 не обязательные:
      v-chip-group(show-arrows)
        v-chip(
          v-for="tag in hint.not_require_tags"
          :key="tag.id"
          color="info"
          close
          @click:close="unBindTag(tag.id)"
          ) {{tag.name}}

    v-row.ma-0.pa-0
      v-spacer
      v-btn.mr-2(color="primary" @click="dialogProj=true") Привязать к проекту
      v-btn(color="primary" @click="dialog=true") Привязать ключевое слово

  v-dialog(v-model="dialogProj" max-width="900")
    v-card(dark)
      v-card-title Привязка вопроса к проекту
      v-card-text
        v-select(
          v-model="selectedProject"
          multiple
          label="Выберите проекты"
          :items="projects"
          item-text="name"
          item-value="id"
        )
      v-card-actions
        v-btn(color="error" @click="resetDialogs") Отмена
        v-spacer
        v-btn(color="success" @click="bindProject") Сохранить

  v-dialog(v-model="dialog" max-width="900")
    v-card(dark)
      v-card-title Редактирование ключевых слов
      v-card-text
        autocomplete-key-words(
          v-model="selectedKeyWords"
          return-object
        )
        h4(v-if="selectedKeyWords.length") Выберите обязательные поля:
          v-checkbox(
            v-for="(keyWord, idx) in selectedKeyWords"
            :key="idx"
            v-model="keyWord.require"
            :label="keyWord.name"
          )
      v-card-actions
        v-btn(color="error" @click="resetDialogs") Отмена
        v-spacer
        v-btn(color="success" @click="bindKeyWord") Сохранить
</template>
<script>
import autocompleteKeyWords from './autocompleteKeyWords.vue';
import autoAnswerService from '@/services/API/autoAnswer';

export default {
  name: 'AutoAnsewerSettings',
  components: {
    autocompleteKeyWords,
  },
  props: {
    hint: { type: Object, required: true },
    keyWords: { type: Array, default: () => [] },
    projects: { type: Array, default: () => [] },
  },
  data() {
    return {
      require: false,
      selectedProject: [],
      selectedKeyWords: [],
      dialog: false,
      dialogProj: false,
      loading: true,
    };
  },
  computed: {
    filtredKeywords() {
      const inputKeywords = [...this.hint.require_tags, ...this.hint.not_require_tags];
      return this.keyWords.filter((item) => !inputKeywords.some((el) => el.id === item.id));
    },
  },
  methods: {
    resetDialogs() {
      this.dialogProj = false;
      this.dialog = false;
      this.selectedKeyWords = [];
      this.require = false;
    },

    async bindKeyWord() {
      const mapedKeyWords = this.selectedKeyWords.map((item) => ({
        id: item.id,
        require: item.require || false,
      }));
      try {
        await autoAnswerService.bindKeyWord(this.hint.id, { tags: mapedKeyWords });
        this.$toast.success('Успешно привязано');
        this.$emit('update');
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
      this.resetDialogs();
    },

    async unBindTag(id) {
      try {
        await autoAnswerService.unBindKeyWord(this.hint.id, { tag_ids: [id] });
        this.$toast.success('Успешно отвязанно');
        this.$emit('update');
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async unBindProject(id) {
      try {
        await autoAnswerService.unBindProject(this.hint.id, { project_ids: [id] });
        this.$toast.success('Успешно отвязанно');
        this.$emit('update');
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },

    async deleteHint() {
      try {
        await autoAnswerService.deleteHint(this.hint.id);
        this.$emit('update');
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },

    async bindProject() {
      try {
        await autoAnswerService.bindProject(this.hint.id, { project_ids: this.selectedProject });
        this.$toast.success('Успешно привязано');
        this.$emit('update');
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
      this.resetDialogs();
    },
  },
};
</script>
